module.exports = __webpack_public_path__ + "media/images/social/social-75455f5a1f2489a94076f0b439959ecc.png";